@if (!showInitialLoader) {
  <div>
    <div class="row align-items-end">
      <div class="col-auto col-sm-6 col-md-12 col-lg-auto form-group">
        <button class="btn btn-primary btn-small" (click)="downloadCSV()" [disabled]="disableWhenNoDataOrDownloading">
          <i [class]="downloadingCsv ? 'fa fa-spinner fa-spin' : 'fa fa-download'"></i>
          {{ 'priceSupportAgreement.downloadAgreementsHistory' | cxTranslate }}
        </button>
      </div>
      <div class="col-12 col-sm-6 col-md form-group">
        <app-custom-search-input
          title="Search Agreement"
          placeholder="Search by End User Name or Agreement Number #"
          (eventSearch)="onSearch($event)"
        ></app-custom-search-input>
      </div>
      <div class="col col-sm col-md-auto form-group">
        <app-custom-select
          [title]="'shared.filterBy' | cxTranslate"
          (changeValue)="filterChange($event)"
          [options]="filterOptions"
          [clearable]="true"
          placeHolder="Status"
        ></app-custom-select>
      </div>
      <div class="col col-sm col-md-auto form-group">
        <app-custom-select
          [title]="'shared.sortBy' | cxTranslate"
          (changeValue)="sortChange($event)"
          [clearable]="true"
          [options]="sortOptions"
          [placeHolder]="'shared.select' | cxTranslate"
        ></app-custom-select>
      </div>
    </div>
  </div>
}

@if (agreementList?.results?.length) {
  <app-custom-table
    [headers]="headers"
    [columns]="columns"
    override="PriceAgreementHistoryRows"
    rowId="orderCode"
    [rows]="agreementList.results"
    [pagination]="agreementList.pagination"
    (changePagination)="pageChange($event + 1)"
    [showLoader]="showLoaderOnPagination"
    >
  </app-custom-table>
} @else {
  @if (showMessageWhenNoData) {
    <app-custom-error
      [errorMessage]="'shared.noAgreements' | cxTranslate"
    ></app-custom-error>
  }
}


@if (showLoaderOnStartupOrWhenNoData) {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
}
